'use strict';

import { combineReducers } from 'redux';
import update from 'immutability-helper';
import * as types from './types';
import { guid } from '@/state/utilities';

const errors = (state = {}, action) => {

	let errors, data, message, uuid;

	switch (action.type) {

		case types.ADD_ERROR:

			({ data } = action);
			({ message } = data);

			message =  message || 'An unknown error has occurred';

			uuid = guid();

			return { ...state, [ uuid ]: { message } };

		case types.REMOVE_ERROR:

			({ data } = action);
			({ uuid } = data);

			return Object.fromEntries(
				Object.entries(state).filter(([ key, val ]) => key !== uuid)
			);

		default:
			return state;
	}
}

export default errors;
